var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamBottomBgSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 375,
    viewBox: "0 0 650 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 125,
    transform: "matrix(1 0 0 -1 62.5 204)",
    fill: "#FFBE1D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 125,
    transform: "matrix(1 0 0 -1 274.5 125)",
    fill: "#FFBE1D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 85,
    transform: "matrix(1 0 0 -1 384.5 250)",
    fill: "#FFBE1D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 85,
    transform: "matrix(1 0 0 -1 529.5 174)",
    fill: "#FFBE1D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 48.5,
    transform: "matrix(1 0 0 -1 187 298.5)",
    fill: "#FFBE1D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 28,
    transform: "matrix(1 0 0 -1 -6.5 347)",
    fill: "#FFBE1D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 28,
    transform: "matrix(1 0 0 -1 483.5 335)",
    fill: "#FFBE1D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 125,
    transform: "matrix(1 0 0 -1 712.5 204)",
    fill: "#FFBE1D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 28,
    transform: "matrix(1 0 0 -1 643.5 347)",
    fill: "#FFBE1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBottomBgSm);
export default __webpack_public_path__ + "static/media/team-bottom-bg-sm.ee85feaadb701def68fd9dce73a07e15.svg";
export { ForwardRef as ReactComponent };